import { useLocation } from 'react-router';
import { EditIcon } from '@chakra-ui/icons'
import {
  Box,
  Flex,
  HStack,
  Icon,
  Image,
  Progress,
  Stack,
  Text,
  Tooltip,
  VStack,
} from '@chakra-ui/react'
import { isNil } from 'lodash'
import { NavLink } from 'react-router-dom'
import activiteImg from 'src/asset/images/activites.svg'
import activiteWhiteImg from 'src/asset/images/activities_white.svg'
import chaptersImg from 'src/asset/images/chapters.svg'
import lessonImg from 'src/asset/images/lesson.svg'
import { getAdminAppUrl } from 'src/util/getAdminAppUrl'
import { getCourseCreatorName } from 'src/util/helpers'

import clock from '../asset/images/clock.svg'
import profile from '../asset/images/profile2x.png'
import { noImageFoundText } from "src/component/constants"
import PlayBtn from './common/PlayBtn/PlayBtn'
import CustomTooltip from './common/CustomTooltip/CustomTooltip';

const RenderNavLink = props => {
  return props.hasStartButton || props.url ? (
    <NavLink to={props.url} aria-label={`Go to ${props.name} Course`}>{props.children}</NavLink>
  ) : (
    <>{props.children}</>
  )
}

export default function ImageCard({
  src,
  name,
  id,
  auth,
  navUrl,
  hasStartButton,
  hrs,
  minutes,
  progress,
  contentEditable,
  isAdmin,
  page,
  showProgress,
  continueLearning,
  lessonCount,
  activitiesCount,
  chapterCount,
  linkedExerciseCount,
  linkedVocabularyCount,
  seconds,
  showCardMetaData = true,
  cardWidth,
  cardWHeight,
  cardRatio
}) {
  const property = {
    imageAlt: '',
    title: name || 'Untitled',
  }
  let url = continueLearning ? `/${navUrl}` : `/${navUrl}/${id}`

  const onCourseEditClick = id => {
    window.open(getAdminAppUrl() + `app/${page}?_id=${id}`, '_blank')
  }

  const showExAndVocb =
    !isNil(linkedExerciseCount) || !isNil(linkedVocabularyCount)
  hrs = hrs > 0 ? hrs : "";
  minutes = minutes === "0" ? (hrs > 0 ? '00' : minutes) : minutes <= 9 ?  (hrs > 0 ? "0" + minutes : minutes ): minutes
  seconds =
    seconds === '0' || !seconds ? '00' : seconds <= 9 ? '0' + seconds : seconds

  const dummyImage = "https://cdn.langistan.com/media/start%20hindi%20here.jpg";

  return (
    <Box
      // minW="xs"
      maxW={cardWidth}
      width="100%"
      borderRadius="md"
      // overflow="hidden"
      position="relative"
      marginInlineStart="0"
      className="imageCard"
    >
      <RenderNavLink url={url} hasStartButton={hasStartButton}>
        <Box position="relative" width="100%">
          <VStack width="100%">
            {!hasStartButton && (
              <PlayBtn />
            )}
            <Box
              maxW={cardWidth}
              // height={`${isActivePath ? "200px" : "168.75px"}`}
              height={cardWHeight}
              borderRadius="md"
              overflow="hidden"
              className="first-wrapper"
              position="relative"
              zIndex={3}
              sx={{ aspectRatio: cardRatio ? cardRatio : "16 / 9" }}
            >
              <Image
                src={src || dummyImage}
                alt={property.imageAlt}
                objectFit="cover"
                width="100%"
                height="100%"
                borderRadius="md"
                transition="transform 0.3s ease-in-out"
                _hover={{ transform: "scale(1.06)" }}
                sx={{ aspectRatio: cardRatio ? cardRatio : "16 / 9" }}
              />
            </Box>
            {showExAndVocb && (
              <>
                {/* video duration */}
                <Text
                  fontSize="12px"
                  whiteSpace="nowrap"
                  marginTop="0px"
                  p={1}
                  style={{
                    zIndex: "999",
                    fontWeight:"500",
                    backgroundColor: 'rgba(0, 0, 0, 0.7)',
                    color: 'white',
                    padding: '2px 4px',
                    borderRadius: '3px',
                    position: 'absolute',
                    bottom: '8px',
                    right: '8px',
                  }}
                >
                  {hrs}{hrs > 0 && ":"}{minutes}:{seconds}
                </Text>
                {/* Activities */}
                <HStack
                  alignItems="center"
                  sx={{
                    backgroundColor: 'rgba(0, 0, 0, 0.8)',
                    color: 'white',
                    padding: '2px 4px',
                    borderRadius: '5px',
                    position: 'absolute',
                    top: '0px',
                    right: '8px',
                    zIndex: 999,
                  }}
                >
                  <Image
                    src={activiteWhiteImg}
                    alt={noImageFoundText}
                    size={'sm'}
                    style={{
                      right: '90px',
                      color: '#fff',
                      width: '29px',
                      padding: '6px',
                    }}
                  ></Image>
                  <Text
                    fontSize="14px"
                    fontWeight={'500'}
                    whiteSpace="nowrap"
                    p={1}
                    style={{
                      right: '0',
                      color: '#fff',
                      textAlign: 'center',
                      paddingLeft: "0px",
                      marginLeft: "0px"
                    }}
                  >
                    {linkedExerciseCount + linkedVocabularyCount} Activities
                  </Text>
                </HStack>
              </>
            )}
          </VStack>
        </Box>
      </RenderNavLink >
      {showProgress && (
        <HStack spacing="2px" marginTop="0px">
          <Box w="100%">
            <Progress
              borderRadius={2}
              colorScheme={progress === 100 ? 'green' : 'red'}
              size="xs"
              value={progress}
              aria-label={`Course progress: ${progress}% completed`}
              sx={{
                '& > div': {
                  background: progress === 100 ? 'green' : 'red',
                },
              }}
            />
          </Box>
        </HStack>
      )
      }
      <Box pt="16px" pl="5px" pr="16px" pb="2" width="100%">
        <Stack gap="1" width="100%">
          <Box
            fontWeight="semibold"
            lineHeight="tight"
            isTruncated
            className="title"
            width="100%"
            mt={-2}
          >
            <CustomTooltip
              label={property.title.charAt(0).toUpperCase() + property.title.slice(1)}
              aria-label="A tooltip"
            >
              <Text display="inline" fontSize={14} textTransform="capitalize">
                {property.title}
              </Text>
            </CustomTooltip>
          </Box>
          {!showProgress && (
            <HStack>
              <Image boxSize="20px" alt={noImageFoundText} src={profile} />
              <Text fontSize="xs" whiteSpace="nowrap">
                {getCourseCreatorName(auth)}
              </Text>
              <Image
                boxSize="20px"
                src={clock}
                alt={noImageFoundText}
                style={{ marginLeft: '28px' }}
              />
              <Text fontSize="xs" whiteSpace="nowrap">
                {hrs} hr {minutes} min
              </Text>
            </HStack>
          )}
          {!showExAndVocb && showCardMetaData && (
            <HStack
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center"
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "start",
                  alignItems: "center",
                  gap: "10px"
                }}
              >
                <Image src={chaptersImg} alt={noImageFoundText} size={'sm'}></Image>
                <Text fontSize="xs" whiteSpace="nowrap">
                  {chapterCount} Chapters
                </Text>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "start",
                  alignItems: "center",
                  gap: "10px"
                }}
              >
                <Image src={lessonImg} alt={noImageFoundText} size={'sm'}></Image>
                <Text fontSize="xs" whiteSpace="nowrap">
                  {lessonCount} Lessons
                </Text>
              </Box>
            </HStack>
          )}
          <HStack
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center"
            }}
          >
            {!showExAndVocb && showCardMetaData &&
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "start",
                  alignItems: "center",
                  gap: "10px"
                }}
              >
                <Image src={activiteImg} alt={noImageFoundText} size={'sm'}></Image>
                <Text fontSize="xs" whiteSpace="nowrap">
                  {activitiesCount} {`Exercise${activitiesCount > 1 ? "s" : ""}`}
                </Text>
              </Box>
            }
            
            {/* content Update button */}
              <Flex justifyContent={'center'} cursor={"pointer"}>
                {isAdmin && contentEditable && (
                  <CustomTooltip
                    label="Update"
                  >
                    <Icon
                      ml={3}
                      onClick={e => {
                        e.preventDefault()
                        onCourseEditClick(id)
                      }}
                      as={EditIcon}
                    />
                  </CustomTooltip>
                )}
              </Flex>
          </HStack>
        </Stack>
      </Box>
    </Box >
  )
}
